import type { FormFieldType } from "../types/form-builder";

/** Shared labels/descriptions for field types (Form builder + properties panel). */
export const FORM_FIELD_TYPE_DEFINITIONS: Array<{
  type: FormFieldType;
  label: string;
  description: string;
}> = [
  {
    type: "text",
    label: "ຂໍ້ຄວາມ",
    description: "ຊ່ອງຂໍ້ຄວາມສັ້ນ",
  },
  {
    type: "textarea",
    label: "ຂໍ້ຄວາມຍາວ",
    description: "ຊ່ອງຂໍ້ຄວາມຫຼາຍແຖວ",
  },
  {
    type: "number",
    label: "ຕົວເລກ",
    description: "ຊ່ອງຕົວເລກ",
  },
  {
    type: "date",
    label: "ວັນທີ",
    description: "ເລືອກວັນທີ",
  },
  {
    type: "time",
    label: "ເວລາ",
    description: "ເລືອກເວລາ",
  },
  {
    type: "datetime",
    label: "ວັນທີແລະເວລາ",
    description: "ເລືອກວັນທີແລະເວລາ",
  },
  {
    type: "email",
    label: "ອີເມວ",
    description: "ຊ່ອງອີເມວ",
  },
  {
    type: "phone",
    label: "ເບີໂທ",
    description: "ຊ່ອງເບີໂທ",
  },
  {
    type: "select",
    label: "ເລືອກຕົວເລືອກ",
    description: "ເລືອກຈາກລາຍການ",
  },
  {
    type: "multiselect",
    label: "ເລືອກຫຼາຍຕົວເລືອກ",
    description: "ເລືອກຫຼາຍລາຍການ",
  },
  {
    type: "checkbox",
    label: "ການກວດສອບ",
    description: "ການກວດສອບ",
  },
  {
    type: "radio",
    label: "ປຸ່ມລາດິໂອ",
    description: "ເລືອກຫນຶ່ງຕົວເລືອກ",
  },
  {
    type: "file",
    label: "ແຟ້ມ",
    description: "ອັບໂຫຼດແຟ້ມ",
  },
  {
    type: "signature",
    label: "ລາຍເຊັນ",
    description: "ລາຍເຊັນດິຈິຕອນ",
  },
];
